import defaultTheme from "../../shared/defaultTheme";
import {Breakpoint, Layout, Template} from "./contract/template";
import {ConfigState, LeadFormState} from "./contract/setting";
import {string} from "react-proptypes";
import {Theme} from "@emotion/react";

declare const ENV: { RELEASE_STAGE: 'development' | 'production'; HOT_ENABLED: boolean };

export const releaseStage = ENV.RELEASE_STAGE;

export const config: ConfigState = {
  base: '/news',
  framed: false,
  prefix: 'news',
  template: null,
  environment: 'production',
  widgets: [],
  landingPage: string,
  news_facebook_enabled: false,
  news_twitter_enabled: false,
  news_linked_in_enabled: false,
}

export const theme: Theme = {
  ...defaultTheme,
  small: '(max-width: 479px)',
  fontFamily: '"Inter", Helvetica, Arial, "Lucida Grande", sans-serif',
  overlayColor: "#fffffe", // hard-coded, used only to superimpose text on photographic material
}

export const lead_form: LeadFormState = {
  showLeadButton: false,
  leadButtonText: null,
  leadAddressInformation: false,
  leadButtonUrl: null,
  leadFormHeader: null,
  leadFormIntroduction: null,
  leadFormSuccessMessage: null,
  leadFormText: null,
  leadReceiver: null,
  leadMailReceiver: null,
  leadFormEmailOnly: null,
};

export const templates: Layout[] = [{
  id: 'spotlight-a-4',
  label: 'Spotlight A (4 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 4,
      sections: [
        [Template.LARGE_SPOTLIGHT, 3],
        [Template.MEDIUM_SPOTLIGHT, 4],
      ]
    },
    [Breakpoint.TABLET]: {
      columns: 3,
      sections: [
        [Template.LARGE_SPOTLIGHT, 2],
        [Template.MEDIUM_SPOTLIGHT, 3],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    }
  }
}, {
  id: 'spotlight-a-3',
  label: 'Spotlight A (3 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 3,
      sections: [
        [Template.LARGE_SPOTLIGHT, 2],
        [Template.MEDIUM_SPOTLIGHT, 3],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    }
  }
}, {
  id: 'spotlight-a-2',
  label: 'Spotlight A (2 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    }
  }
}, {
  id: 'spotlight-b-4',
  label: 'Spotlight B (4 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 4,
      sections: [
        [Template.LARGE_SPOTLIGHT, 3],
        [Template.MEDIUM, 4],
      ]
    },
    [Breakpoint.TABLET]: {
      columns: 3,
      sections: [
        [Template.LARGE_SPOTLIGHT, 2],
        [Template.MEDIUM, 3],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    }
  }
}, {
  id: 'spotlight-b-3',
  label: 'Spotlight B (3 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 3,
      sections: [
        [Template.LARGE_SPOTLIGHT, 2],
        [Template.MEDIUM, 3],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    }
  }
}, {
  id: 'spotlight-b-2',
  label: 'Spotlight B (2 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM, 2],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    }
  }
}, {
  id: 'spotlight-c-4',
  label: 'Spotlight C (4 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 4,
      sections: [
        [Template.LARGE, 1],
        [Template.MEDIUM_SPOTLIGHT, 4],
      ]
    },
    [Breakpoint.TABLET]: {
      columns: 3,
      sections: [
        [Template.LARGE, 1],
        [Template.MEDIUM_SPOTLIGHT, 3],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    }
  }
}, {
  id: 'spotlight-c-3',
  label: 'Spotlight C (3 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 3,
      sections: [
        [Template.LARGE, 1],
        [Template.MEDIUM_SPOTLIGHT, 3],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    }
  }
}, {
  id: 'spotlight-c-2',
  label: 'Spotlight C (2 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 2,
      sections: [
        [Template.LARGE, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.LARGE_SPOTLIGHT, 1],
        [Template.MEDIUM_SPOTLIGHT, 2],
      ]
    }
  }
}, {
  id: 'magazine-4',
  label: 'Magazine (4 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 4,
      sections: [
        [Template.MEDIUM, 8],
      ]
    },
    [Breakpoint.TABLET]: {
      columns: 3,
      sections: [
        [Template.MEDIUM, 6],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.MEDIUM_SPOTLIGHT, 4],
      ]
    }
  }
}, {
  id: 'magazine-3',
  label: 'Magazine (3 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 3,
      sections: [
        [Template.MEDIUM, 6],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.MEDIUM_SPOTLIGHT, 4],
      ]
    }
  }
}, {
  id: 'magazine-2',
  label: 'Magazine (2 columns)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 2,
      sections: [
        [Template.MEDIUM, 4],
      ]
    },
    [Breakpoint.MOBILE]: {
      columns: 2,
      sections: [
        [Template.MEDIUM_SPOTLIGHT, 4],
      ]
    }
  }
}, {
  id: 'headlines',
  label: 'Headlines (1 column)',
  breakpoints: {
    [Breakpoint.DESKTOP]: {
      columns: 1,
      sections: []
    },
    [Breakpoint.MOBILE]: {
      columns: 1,
      sections: []
    }
  }
}];

export enum PublicationStatus {
  PLANNED = 'Planned',
  CONCEPT = 'Concept',
  READY_FOR_REVIEW = 'Ready for Review',
  PUBLISHED = 'Published',
  ARCHIVED = 'Archived',
  DELETED = 'Deleted',
  ERROR = 'Error',
}
